import { render, staticRenderFns } from "./create-or-edit-bankInfo.vue?vue&type=template&id=e87a9f08&scoped=true&"
import script from "./create-or-edit-bankInfo.vue?vue&type=script&lang=js&"
export * from "./create-or-edit-bankInfo.vue?vue&type=script&lang=js&"
import style0 from "./create-or-edit-bankInfo.vue?vue&type=style&index=0&id=e87a9f08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87a9f08",
  null
  
)

export default component.exports